<template>
  <v-navigation-drawer
    id="appNavigationDrawer"
    style="z-index: 1000"
    :class="{ 'elevation-8': $vuetify.breakpoint.mdAndUp }"
    absolute
    :temporary="true"
    v-model="showAppDrawer"
  >
    <v-toolbar
      id="appNavigationDrawerToolbar"
      style="margin.bottom: 10px;"
      color="primary white--text"
    >
      <img alt="NVE logo" style="height: 40px;" :src="getImgUrl(logoImagePath)" />
      <v-toolbar-title>{{ appTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn label="Lukk meny" aria-label="Lukk meny" @click="hideAppDrawer" class="white--text" icon>
        <v-icon>chevron_left</v-icon>
      </v-btn>
    </v-toolbar>

    <v-list>
      <v-subheader>Mine kart</v-subheader>
      <v-list-tile @click="openCreateNewEmptyDialog">
        <v-list-tile-avatar size="25">
          <v-icon>mdi-file-outline</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Tomt kart</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="activateOpenProjectDialog">
        <v-list-tile-avatar size="25">
          <v-icon>mdi-folder-open</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Åpne kart</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="saveProject" :disabled="!saveIsEnabled">
        <v-list-tile-avatar size="25">
          <v-icon>mdi-content-save</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Lagre kart</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="saveProjectAs()" :disabled="!currentlyOpenedProject">
        <v-list-tile-avatar size="25">
          <v-icon>mdi-content-save-settings-outline</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Lagre som..</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider />

    <v-subheader>Bakgrunn</v-subheader>

    <v-list v-if="basemaps && selectedBasemap">
      <v-list-tile
        v-for="item in basemaps"
        :key="item.id"
        @click="selectedBasemap = item"
      >
        <v-list-tile-avatar size="30">
          <img :alt="'Bilde som representerer bakgrunnskart ' + item.title" :src="item.thumbnailUrl" />
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title
            :class="{ 'blue--text': selectedBasemap.id == item.id }"
            >{{ item.title }}</v-list-tile-title
          >
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>

    <v-list>
      <v-subheader>Verktøy</v-subheader>
      <v-list-tile
        v-for="(item, name) in tools"
        v-show="
          !item.hasOwnProperty('hideInMenus') || item.hideInMenus === false
        "
        :key="name"
        @click="toggleContent(name)"
      >
        <v-list-tile-avatar size="30">
          <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
          <span v-if="item.text" style="font-weight: bold; color: gray">
            {{ item.text }}
          </span>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title :class="{ 'blue--text': item.active }">
            {{ item.title }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="togglePhotoStreamActivated">
        <v-list-tile-avatar size="30">
          <v-icon>mdi-camera</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{
            photoStreamIsActivated ? "Skjul fotostrøm" : "Vis fotostrøm"
          }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <v-subheader>Om løsningen</v-subheader>

      <v-list-tile
        :href="
          'mailto:gisstotte@nve.no?Subject=' + appTitle + '%20tilbakemelding'
        "
        target="_top"
      >
        <v-list-tile-avatar size="30">
          <v-icon>mdi-message</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Kontakt oss</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        href="https://www.nve.no/nves-personvernerklaering/"        
      >
        <v-list-tile-avatar size="30">
          <v-icon>mdi-human</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Personvern</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile :disabled="guideIsRunning" @click="showGuide">
        <v-list-tile-avatar size="30">
          <v-icon>mdi-lifebuoy</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Vis guide</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="showTechnologyPopup">
        <v-list-tile-avatar size="30">
          <v-icon>mdi-file-code-outline</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Teknologi</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="showSettingsDialog">
        <v-list-tile-avatar size="30">
          <v-icon>mdi-settings</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>Innstillinger</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider />

      <v-subheader>Lenker</v-subheader>

      <v-list-tile href="https://www.nve.no">
        <v-list-tile-avatar size="30">
          <v-icon>mdi-link</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>NVE.no forsiden</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile href="https://atlas.nve.no">
        <v-list-tile-avatar size="30">
          <v-icon>mdi-link</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>NVE Atlas</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile href="https://nedlasting.nve.no/gis/">
        <v-list-tile-avatar size="30">
          <v-icon>mdi-link</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>NVE Nedlasting av fagdata</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-divider />
    <p style="padding: 15px; font-size: 12px;">
      Attribusjon for kartdata: Kartverket, Geovekst og kommuner - Geodata AS |
      NVEs kartdata distribueres i henhold til
      <a href="https://data.norge.no/nlod/no"
        >Norsk lisens for offentlige data (NLOD).</a
      >
    </p>

    <open-project-dialog
      :active="openProjectDialogActive"
      @close-dialog="deactivateOpenProjectDialog"
    ></open-project-dialog>
    <save-project-dialog
      v-if="saveProjectDialogActive"
      :active="saveProjectDialogActive"
      :save-project-settings="saveProjectSettings"
      @close-dialog="deactivateSaveProjectDialog"
    ></save-project-dialog>

    <confirm-dialog
      :active="confirmNewEmptyProjectDialog"
      :text="confirmNewEmptyProjectDialogText"
      title="Åpne nytt tomt kart"
      confirm-text="Ja"
      reject-text="Nei"
      @dialog-confirmed="createNewEmptyProject"
      @dialog-rejected="closeConfirmNewEmptyProjectDialog"
    />

    <confirm-dialog
      :active="technologyDialogOpen"
      text="<p>Denne applikasjonen er utviklet av NVE. Applikasjonen er først og fremst en innsynsklient mot NVE sine kartdata, men tilbyr også andre GIS-funksjoner og analyser.</p><p>Applikasjonen er laget med Javascript, HTML og CSS. Rammeverkene Vue, Vuex og Vuetify er brukt for brukergrensesnitt og tilstandshåndtering. Kartvisning, kartverktøy og kommunikasjon med karttjenester håndteres ved hjelp av ArcGIS API for Javascript.</p><p>Kartdata hentes i hovedsak fra ArcGIS-baserte REST tjenester. Bakgrunnskart, høydemodell, adressesøk, og 3D bygg hentes fra tjenester som tilbys via Geodata Online. Kartdata fra NVE hentes fra karttjenestene våre. Tjenestene til NVE er i de fleste tilfeller åpne og kan brukes av alle.</p>"
      title="Teknologien bak løsningen"
      confirm-text="Lukk"
      :show-reject-button="false"
      @dialog-confirmed="technologyDialogOpen = false"
    />

    <settings-dialog />
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OpenProjectDialog from "@/pages/MapPage/Tools/Saving/OpenProjectDialog";
import SaveProjectDialog from "@/pages/MapPage/Tools/Saving/SaveProjectDialog";
import SettingsDialog from "@/components/SettingsDialog";
import ConfirmDialog from "@/components/ConfirmDialog";
import MappingMixin from "@/mixins/mappingMixin";
import BasemapMixin from "@/mixins/basemapMixin";

export default {
  name: "TheAppDrawer",
  components: {
    OpenProjectDialog,
    SaveProjectDialog,
    ConfirmDialog,
    SettingsDialog
  },
  mixins: [MappingMixin, BasemapMixin],
  computed: {
    ...mapState([
      "appTitle",
      "basemaps",
      "tools",
      "currentlyOpenedProject",
      "saveIsEnabled",
      "guideIsRunning",
      "isConnectedToIntranet",
      "logoImagePath"
    ]),
    photoStreamIsActivated: {
      set(photoStreamIsActivated) {
        this.setPhotoStreamIsActivated(photoStreamIsActivated);
      },
      get() {
        return this.$store.state.photoStreamIsActivated;
      }
    },
    confirmNewEmptyProjectDialogText() {
      if (this.currentlyOpenedProject == null) {
        return "Når man oppretter et nytt tomt kart vil alt innhold fjernes fra kartet. Er du sikker på at du ønsker å fortsette?";
      } else {
        return (
          "Hvis du har gjort endringer i kartet '" +
          this.currentlyOpenedProject.attributes.tittel +
          "' som du ønsker å ta vare på må disse lagres før du fortsetter. Er du sikker på at du ønsker å fortsette?"
        );
      }
    },
    selectedBasemap: {
      set(selectedBasemap) {
        this.setBasemap(selectedBasemap);
        this.hideAppDrawer();
      },
      get() {
        return this.$store.state.selectedBasemap;
      }
    },
    showAppDrawer: {
      set(showAppDrawer) {
        this.setShowAppDrawer(showAppDrawer); // bytte til setShowAppDrawer
      },
      get() {
        return this.$store.state.showAppDrawer;
      }
    }
  },
  watch: {
    showAppDrawer(newVal) {
      if (!newVal) {
        this.scrollToTop();
      }
    }
  },
  methods: {
    ...mapActions([
      "enableSave",
      "setSnack",
      "removeCurrentlyOpenedProject",
      "setGuideIsRunning",
      "setSettingsDialogActive",
      "setPhotoStreamIsActivated",
      "setShowAppDrawer"
    ]),
    getImgUrl(svgName) {
      let images = require.context("../../../assets/", false, /\.(svg|png)$/);
      return images("./" + svgName);
    },
    togglePhotoStreamActivated: function() {
      this.photoStreamIsActivated = !this.photoStreamIsActivated;
      this.hideAppDrawer();
    },
    showTechnologyPopup: function() {
      this.technologyDialogOpen = true;
      this.hideAppDrawer();
    },
    scrollToTop: function() {
      this.$vuetify.goTo("#appNavigationDrawerToolbar", {
        container: "#appNavigationDrawer",
        offset: 0
      });
    },
    hideAppDrawer: function() {
      this.scrollToTop();
      this.setShowAppDrawer(false);
    },
    showSettingsDialog: function() {
      this.hideAppDrawer();
      this.setSettingsDialogActive(true);
    },
    showGuide: function() {
      this.$tours["myTour"].start();
      this.setGuideIsRunning(true);
      this.hideAppDrawer();
    },
    goToCatalogue: function() {
      this.hideAppDrawer();
      this.$router.push("/");
    },
    toggleContent: function(toolName) {
      this.showAppDrawer = false;
      this.$eventHub.$emit("toggle-tool", toolName);
    },
    openCreateNewEmptyDialog() {
      this.confirmNewEmptyProjectDialog = true;
      this.hideAppDrawer();
    },
    createNewEmptyProject() {
      this.removeAllMapProfiles();
      this.removeCurrentlyOpenedProject();
      this.enableSave();
      this.closeConfirmNewEmptyProjectDialog();
    },
    closeConfirmNewEmptyProjectDialog() {
      this.confirmNewEmptyProjectDialog = false;
    },
    saveProject() {
      this.hideAppDrawer();
      if (this.currentlyOpenedProject == null) {
        this.saveProjectSettings = false;
        this.activateSaveProjectDialog();
      } else {
        this.projectSaveInProgress = true;
        this.saveMap(this.currentlyOpenedProject)
          .then(result => {
            if (!result) {
              this.setSnack(
                "Lagring ble ikke gjennomført. Kun eier kan lagre endringer."
              );
            } else {
              this.setSnack("Kartet ble lagret");
            }
            this.projectSaveInProgress = false;
          })
          .catch(error => {
            console.error(error);
            this.setSnack("Lagring ikke gjennomført. Prøv igjen om litt.");
          });
      }
    },
    changeProjectSettings() {
      this.saveProjectSettings = true;
      this.activateSaveProjectDialog();
    },
    saveProjectAs() {
      this.hideAppDrawer();
      this.saveProjectSettings = false;
      this.activateSaveProjectDialog();
    },
    deactivateOpenProjectDialog() {
      this.openProjectDialogActive = false;
    },
    deactivateSaveProjectDialog() {
      this.saveProjectDialogActive = false;
    },
    deactivateShareProjectDialog() {
      this.shareProjectDialogActive = false;
    },
    activateOpenProjectDialog() {
      this.hideAppDrawer();
      this.openProjectDialogActive = true;
    },
    activateSaveProjectDialog() {
      this.saveProjectDialogActive = true;
    },
    activateShareProjectDialog() {
      this.shareProjectDialogActive = true;
    }
  },
  data: () => ({
    dialog: false,
    drawer: false,
    openProjectDialogActive: false,
    saveProjectDialogActive: false,
    projectSaveInProgress: false,
    confirmNewEmptyProjectDialog: false,
    saveProjectSettings: false,
    technologyDialogOpen: false
  })
};
</script>

<style>
.v-overlay--active {
  z-index: 1000;
}
</style>
